import React from 'react';
const IconMiscGraph = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M10 20H14V4H10V20ZM4 20H8V12H4V20ZM16 20V9H20V20H16Z" fill="#666666"/>
</svg>
);
};
export default IconMiscGraph;